import Button from "../ui/Button";
import "./LandingCta.css";

function LandingCta() {
  return (
    <section className="landing-cta">
      <div className="landing-cta__content">
        <div className="landing-cta__text">
          <h3 className="landing-cta__title">Benieuwd naar de functionaliteiten?</h3>
          <p className="landing-cta__subtitle">
            Boek een demo en we nemen u mee in verschillende toepassingen om de dienstverlening van overheden in beeld te brengen.
          </p>
        </div>
        <div className="landing-cta__actions">
          <Button variant="secondary">Lees meer</Button>
          <Button variant="primary">Boek Demo</Button>
        </div>
      </div>
    </section>
  );
}

export default LandingCta;
